import { action } from "satcheljs";

const resetShiftRequestsStore = action(
    "RESET_SHIFTREQUESTS_STORE", () => ({})
);

export default resetShiftRequestsStore;
